'use strict';
angular.module('cvsApp').controller('storeDetailController', ['$scope', '$state', 'checkStoreopen', '$q', '$window',
    'checkFavoriteStore', 'manageFavoriteStoresService', '$stateParams', 'getStoreLocationService', '$cookies', 'cvsAppData', '$rootScope', 'webTrendsService', 'retrieveTimeStampService','$uibModal', '$timeout',
    function($scope, $state, $checkStoreopen, $q, $window, CFS, MFS, $stateParams, GSLS, $cookies, CAD, $rootScope, WTS, RTSS,$uibModal, $timeout) {
        $scope.SDC = this;

        angular.element("#specialtySpinner").show();
        angular.element("#loader").show();
        var utagObj = {};
        utagObj.page_name = "Store Details";
        utagObj.page_category = "Store Details";
        WTS.webTrendsUtag("OBJ", utagObj);
        $scope.SDC.storeNumber = $stateParams.storeNumber;
        $scope.SDC.distance = $stateParams.distance;

        try {
            if (native) {
                native.setDefaultHeader('Store Detail', true, true);
            }
        } catch (ex) {

        }
        var tokenID, tokenType, storeId
        tokenID = CAD.getTokenId() ? CAD.getTokenId() : cvsUtility.queryMap.tokenId;
        tokenType = CAD.getTokenType() ? CAD.getTokenType() : 'Login';
        var storeName = true;
        var itemToBeAdded;
        var storeNumber = $scope.SDC.storeNumber,
            lati = '',
            longi = '';
        var storeDetails = {
            apiKey: cvsUtility.queryMap.apikey,
            address: storeName ? $scope.SDC.storeName : "",
            storeNumber: storeNumber ? $scope.SDC.storeNumber : "",
            iPAddress: "",
            latitude: lati ? lati : "",
            longitude: longi ? longi : "",
            radius: 10,
            maxResults:100,
            tokenID: tokenID,
            tokenType: tokenType,
            driveThru: "N",
            store24HR: "N",
            carePlus: "N",
            immunization: $scope.SDC.immunization ? 'Y' : 'N',
            minuteClinic: $scope.SDC.minuteclinic ? 'Y' : 'N',
            pharmacy24HR: $scope.SDC.Pharmacy24hr ? 'Y' : 'N',
            // token: cvsUtility.queryMap.token
            // timeStamp: cvsUtility.queryMap.timeStamp ? cvsUtility.queryMap.timeStamp : (cvsUtility.queryMap.timestamp ? cvsUtility.queryMap.timestamp : '')
        };

        $scope.SDC.tokenID = tokenID;
        GSLS.getStoreLocation(storeDetails, storeSuccess, 'PZN');

        function storeSuccess(data) {
            $scope.SDC.store = data.apiResponse.storeDetails.entry.length > 0 ? data.apiResponse.storeDetails.entry[0] : data.apiResponse.storeDetails.entry; // To do need to change the entry[0] as for now we are using mock service we are using this
            $scope.SDC.setStoreDetailsTiming($scope.SDC.store);
            $window.localStorage['recentlyViewedStore'] = angular.toJson($scope.SDC.store);
            $timeout(
                function(){
                    angular.element("#specialtySpinner").hide();
                    angular.element("#loader").hide();
                },500
            )

        }

        RTSS.retrieveTimeStamp(onServerTimeStampSuccess);

                function onServerTimeStampSuccess (data) {
                    if(data.SERVER_ERROR){

                        var pageError = cvsUtility.getPageError(data, 'NonFatal', 'retrieveTimeStamp');
                        WTS.webTrendsUtag("LINK",{ page_error: pageError},undefined);
                        var date=new Date();
                        // $rootScope.serverTimeStamp=date.toUTCString();
                    }

                    if(data.getError() === '') {
                        $rootScope.serverTimeStamp = data.apiResponse.timeStamp?data.apiResponse.timeStamp:'';
                        if($rootScope.serverTimeStamp && typeof $rootScope.serverTimeStamp === "object"){
                            $rootScope.serverTimeStamp.__text = $rootScope.serverTimeStamp.__text.replace(/[\n\t\r]+/g,'');
                        }
                        else{
                            $rootScope.serverTimeStamp = $rootScope.serverTimeStamp.replace(/[\n\t\r]+/g,'');
                        }

                    }else{
                        /**
                         * sankar 02/10/2016 - SMP 009 - retrieveTimeStamp service error
                         * Modified page_error tag
                         */
                        WTS.webTrendsUtag("LINK",{ page_error: 'NonFatal | retrieveTimeStamp | '+data.getError().statusCode+' | '+data.getError().statusDesc},undefined);
                    }

                }

        //$scope.SDC.favid = CFS.favouriteStoreId;
        $scope.SDC.favCookieStore = $cookies.get('favCookieStore');
        $scope.SDC.storeHourstext = [];
        $scope.SDC.promises = [];
        $scope.SDC.day = '';
        $scope.SDC.storeHours = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        $scope.SDC.checkOpen = function(item, pharOrStore) {
            if(item){
                var openStatus = $rootScope.checkOpen(item,pharOrStore);
                if (openStatus) {
                    return true;
                 } else {
                    return false;
                }
            }
        };
        $scope.SDC.showDay = function(day) {
            var today = '';
            if (day === undefined || null) {
                var date = new Date();
                today = date.getDay();
            } else {
                today = day;
            }
            $scope.SDC.day = today;
            return today;

        };
        $scope.SDC.changeday = function(day) {

        }

        $scope.SDC.getDirection = function(store, storenumber) {
            var stringifiedStore = JSON.stringify(store);
            if (cvsUtility.setNativeCheck()) {
                native.locateStoreInMap(stringifiedStore)
            } else if (cvsUtility.isMobile()) {
                var popupWindow = window.open('http://maps.apple.com/?q=' + store.content.properties.AddressLine.__text + ',' + store.content.properties.Locality.__text + ',' + store.content.properties.AdminDistrict.__text + ',' + store.content.properties.PostalCode.__text);
                setTimeout(function() {
                    popupWindow.close();
                }, 5000);
            } else {
                $state.transitionTo('store-direction', {
                    storeNumber: storenumber
                });
            }
        }
        $scope.SDC.openTel = function(number) {
            var origVal = number.replace(/[^\w\s]/gi, '');
            var str, phone;
            if (origVal.length === 10) {
                str = origVal.replace(/(.{3})/g, "$1-");
                phone = str.slice(0, -2) + str.slice(-1);
            }
            if (cvsUtility.setNativeCheck()) {
                native.openExtUrl('tel:' + phone);
            } else {
                $window.open('tel:' + phone)
            }
        }




        $scope.SDC.checkinFav = function(storenumber) {
            if (!$scope.SDC.tokenID && $scope.SDC.favCookieStore) {
                var cookesItems = $cookies.get('favCookieStore');
                for (var i = 0; i < cookesItems.length; i++) {
                    if (cookesItems[i].favCookieStore.storeNumber === storenumber) {
                        return true;
                    }
                }
            } else if ($scope.SDC.tokenID) {
                var favStores = CAD.getFavStores();

                if (favStores.length > 0) {
                    for (var i = 0; i < favStores.length; i++) {
                        if (favStores[i].content.properties.EntityID.__text === storenumber) {
                            return true;
                        }
                    }
                }
            }
            return false;
        }
        $scope.SDC.selectStore = function(item) {
            angular.element("#specialtySpinner").show();
            angular.element("#loader").show();
            itemToBeAdded = item;
            var storeId = item.content.properties.EntityID.__text;
            var lati = item.content.properties.Latitude.__text.replace(/[\n\t\r]+/g,'');
            var longi = item.content.properties.Longitude.__text.replace(/[\n\t\r]+/g,'');
            var utagObj = {};
            utagObj.page_name = "Store Details";
            utagObj.store_id = storeId;
            utagObj.link_name = 'Custom: User Set My CVS';
            WTS.webTrendsUtag("LINK", utagObj);
            var array = [];
            if ($scope.SDC.tokenID) {
                MFS.addFavoriteStore(addressAdded, '', 'addStore', storeId);
            } else {
                array = [];
                array.push({
                    'favCookieStore': {
                        storeNumber: storeId,
                        Latitude: lati,
                        Longitude: longi
                    }
                });
                $cookies.put('favCookieStore', array);
                $scope.SDC.favCookieStore = $cookies.get('favCookieStore');
            }
        }

        $scope.SDC.deleteStore = function(item) {
            angular.element("#specialtySpinner").show();
            angular.element("#loader").show();
            storeId = item.content.properties.EntityID.__text;
            if ($scope.SDC.tokenID) {
                MFS.addFavoriteStore(addressDeleted, '', 'deleteStore', storeId);
            } else {
                $cookies.put('favCookieStore', []);
            }
        }

        function addressDeleted(response) {
            angular.element("#specialtySpinner").hide();
            angular.element("#loader").hide();
            if(response && (response.SERVER_ERROR || response.getError() !== '')){
                var pageError = cvsUtility.getPageError(response, 'Fatal', 'manageFavoriteStores');
                WTS.webTrendsUtag("OBJ",{ page_error: pageError},undefined);
                if(response.getError() !== '' && response.getError().hasOwnProperty('statusDesc')){
                    alert(response.getError().statusDesc);
                }
                  return;
            }
                var favStores = CAD.getFavStores();

                if (favStores.length > 0) {
                    for (var i = 0; i < favStores.length; i++) {
                        if (favStores[i].content.properties.EntityID.__text === storeId) {
                            favStores.splice(i, 1);
                        }
                    }
                }
                CAD.setFavStores(favStores)
        }

        function addressAdded(response) {
            angular.element("#specialtySpinner").hide();
            angular.element("#loader").hide();
            if(response && (response.SERVER_ERROR || response.getError() !== '')){
                var pageError = cvsUtility.getPageError(response, 'Fatal', 'manageFavoriteStores');
                WTS.webTrendsUtag("OBJ",{ page_error: pageError},undefined);
                if(response.getError() !== '' && response.getError().hasOwnProperty('statusDesc')){
                    alert(response.getError().statusDesc);
                }
                  return;
            }
            CAD.pushFavStore(itemToBeAdded);
        }

        $scope.SDC.setStoreDetailsTiming = function(store) {
            angular.forEach($scope.SDC.storeHours, function(val, key) {
                var deferred = $q.defer();
                $scope.SDC.storeHourstext.push({
                    store: {},
                    pharmacy: {}
                });
                $scope.SDC.storeHourstext[key].store.openTime = {};
                $scope.SDC.storeHourstext[key].store.closedTime = {};
                deferred.resolve();
                $scope.SDC.promises.push(deferred.promise);
            });
            $q.all($scope.SDC.promises).then(function() {
                $scope.SDC.storeHourstext[0].store.openTime = store.content.properties.Fs_Sun_Hours.__text && store.content.properties.Fs_Sun_Hours.__text.split()[0];
                $scope.SDC.storeHourstext[0].store.closedTime = store.content.properties.Fs_Sun_Hours.__text && store.content.properties.Fs_Sun_Hours.__text.split()[1];

                $scope.SDC.storeHourstext[1].store.openTime = store.content.properties.Fs_Mon_Hours.__text && store.content.properties.Fs_Mon_Hours.__text.split()[0];
                $scope.SDC.storeHourstext[1].store.closedTime = store.content.properties.Fs_Mon_Hours.__text && store.content.properties.Fs_Mon_Hours.__text.split()[1];

                $scope.SDC.storeHourstext[2].store.openTime = store.content.properties.Fs_Tues_Hours.__text && store.content.properties.Fs_Tues_Hours.__text.split()[0];
                $scope.SDC.storeHourstext[2].store.closedTime = store.content.properties.Fs_Tues_Hours.__text && store.content.properties.Fs_Tues_Hours.__text.split()[1];

                $scope.SDC.storeHourstext[3].store.openTime = store.content.properties.Fs_Wed_Hours.__text && store.content.properties.Fs_Wed_Hours.__text.split()[0];
                $scope.SDC.storeHourstext[3].store.closedTime = store.content.properties.Fs_Wed_Hours.__text && store.content.properties.Fs_Wed_Hours.__text.split()[1];

                $scope.SDC.storeHourstext[4].store.openTime = store.content.properties.Fs_Thur_Hours.__text && store.content.properties.Fs_Thur_Hours.__text.split()[0];
                $scope.SDC.storeHourstext[4].store.closedTime = store.content.properties.Fs_Thur_Hours.__text && store.content.properties.Fs_Thur_Hours.__text.split()[1];

                $scope.SDC.storeHourstext[5].store.openTime = store.content.properties.Fs_Fri_Hours.__text && store.content.properties.Fs_Fri_Hours.__text.split()[0];
                $scope.SDC.storeHourstext[5].store.closedTime = store.content.properties.Fs_Fri_Hours.__text && store.content.properties.Fs_Fri_Hours.__text.split()[1];

                $scope.SDC.storeHourstext[6].store.openTime = store.content.properties.Fs_Sat_Hours.__text && store.content.properties.Fs_Sat_Hours.__text.split()[0];
                $scope.SDC.storeHourstext[6].store.closedTime = store.content.properties.Fs_Sat_Hours.__text && store.content.properties.Fs_Sat_Hours.__text.split()[1];


                // pharmacy text
                $scope.SDC.storeHourstext[0].pharmacy.openTime = store.content.properties.Rx_Sun_Hours.__text && store.content.properties.Rx_Sun_Hours.__text.split()[0];
                $scope.SDC.storeHourstext[0].pharmacy.closedTime = store.content.properties.Rx_Sun_Hours.__text && store.content.properties.Rx_Sun_Hours.__text.split()[1];

                $scope.SDC.storeHourstext[1].pharmacy.openTime = store.content.properties.Rx_Mon_Hours.__text && store.content.properties.Rx_Mon_Hours.__text.split()[0];
                $scope.SDC.storeHourstext[1].pharmacy.closedTime = store.content.properties.Rx_Mon_Hours.__text && store.content.properties.Rx_Mon_Hours.__text.split()[1];

                $scope.SDC.storeHourstext[2].pharmacy.openTime = store.content.properties.Rx_Tues_Hours.__text && store.content.properties.Rx_Tues_Hours.__text.split()[0];
                $scope.SDC.storeHourstext[2].pharmacy.closedTime = store.content.properties.Rx_Tues_Hours.__text && store.content.properties.Rx_Tues_Hours.__text.split()[1];

                $scope.SDC.storeHourstext[3].pharmacy.openTime = store.content.properties.Rx_Wed_Hours.__text && store.content.properties.Rx_Wed_Hours.__text.split()[0];
                $scope.SDC.storeHourstext[3].pharmacy.closedTime = store.content.properties.Rx_Wed_Hours.__text && store.content.properties.Rx_Wed_Hours.__text.split()[1];

                $scope.SDC.storeHourstext[4].pharmacy.openTime = store.content.properties.Rx_Thur_Hours.__text && store.content.properties.Rx_Thur_Hours.__text.split()[0];
                $scope.SDC.storeHourstext[4].pharmacy.closedTime = store.content.properties.Rx_Thur_Hours.__text && store.content.properties.Rx_Thur_Hours.__text.split()[1];

                $scope.SDC.storeHourstext[5].pharmacy.openTime = store.content.properties.Rx_Fri_Hours.__text && store.content.properties.Rx_Fri_Hours.__text.split()[0];
                $scope.SDC.storeHourstext[5].pharmacy.closedTime = store.content.properties.Rx_Fri_Hours.__text && store.content.properties.Rx_Fri_Hours.__text.split()[1];

                $scope.SDC.storeHourstext[6].pharmacy.openTime = store.content.properties.Rx_Fri_Hours.__text && store.content.properties.Rx_Sat_Hours.__text.split()[0];
                $scope.SDC.storeHourstext[6].pharmacy.closedTime = store.content.properties.Rx_Fri_Hours.__text && store.content.properties.Rx_Sat_Hours.__text.split()[1];

            })
        }
    }
]);